const FloatingButtons = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.');
  
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col space-y-3">
      <a
        href={`https://wa.me/905513723512?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
      <a
        href="tel:+905513723512"
        className="w-14 h-14 flex items-center justify-center bg-gray-800 hover:bg-gray-900 text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="Telefon"
      >
        <i className="ri-phone-line text-2xl"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;
